<template>
  <HgButton theme="primary" :class="$style.button" @click="handleClick">
    <slot></slot>
  </HgButton>
</template>

<script setup lang="ts">
import { VALUATION_FORM_PATH } from '@/router/routes/constants';
import { trackingClickEvent } from '@/tracking/tracking';
import { TRACKING_ACTION, TRACKING_LABEL } from '@/tracking/types';
import { HgButton } from '@smg-real-estate/domus';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const { locale } = useI18n();
const { push } = useRouter();

// We assume a user will not hit the limit on an empty overview page,
// hence we always push to the valuation form here and track it as 'under limit'.
const handleClick = () => {
  trackingClickEvent(
    TRACKING_ACTION.GO_TO_VALUATION_FORM,
    TRACKING_LABEL.VALUATION_FUNNEL_MIDDLE_BUTTON,
    true,
    {
      h_extra_information_144: 'property_limit_under',
    },
  );
  push(`${VALUATION_FORM_PATH[locale.value]}`);
};
</script>

<style lang="scss" module>
.button[class*='HgButton_button'] {
  width: 100%;
  max-width: 100%;
}
</style>
